<template>
  <div class="roleMenuAssignDialog">
    <!-- 部分设置弹窗 -->
    <el-dialog
      class="dialog816"
      title="菜单授权"
      :visible.sync="isDialogShow"
      :before-close="hideDialog"
      :close-on-click-modal="false"
    >
      <el-container style="height:100%;">
        <el-aside>
          <div class="menuTitlePanel">菜单</div>
          <el-tree
            ref="menuTree"
            :data="menuList"
            :props="defaultProps"
            :default-checked-keys="menuAssignedList"
            node-key="id"
            @node-click="MenuNodeClick"
            show-checkbox
            :default-expand-all="true"
          ></el-tree>
        </el-aside>
        <el-main>
          <div class="menuTitlePanel">菜单按钮</div>
          <div>
            <el-tree
              ref="btnTree"
              :data="meunBtnList"
              :props="defaultProps"
              show-checkbox
              :default-checked-keys="btnAssignedList"
              @check-change="btnCheckChanged"
              node-key="id"
            ></el-tree>
          </div>
        </el-main>
      </el-container>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="hideDialog()">取 消</el-button>
        <el-button type="primary" @click="saveUserClick()">授 权</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAllMenuService,
  getMenuDetailsService,
  getMenuBtnListService,
  getMenuBtnDetailService,
  getDeptAssginMenuService,
  getDeptGrantMenuBtnService,
  changeDeptMenuService
} from "../../services/sysSettingService";
export default {
  name: "roleMenuAssignDialog",
  data() {
    return {
      menuList: [], //全部菜单列表
      meunBtnList: [], //菜单按钮列表
      menuAssignedList: [], //已授权菜单列表
      btnAssignedList: [], //已授权按钮列表

      menuCheckedKeys: [], //已选菜单
      menuHalfCheckedKeys: [], //半选菜单

      checkedBtns: [], //选中的按钮列表
      checkedBtnNodes: [], //选中的按钮对象列表

      selectMenuCode: [], //用户点击过并获取了按钮列表的menu

      checkedMenuBtns: {}, //用户点击过并勾选的菜单按钮对象

      isScreenShow: false, //高级筛选显示开关
      isDialogShow: false, //新增/修改用户显示开关
      isAddFlag: true, //新增/修改标识
      defaultProps: {
        label: "text",
        children: "children",
        value: "id"
      }
    };
  },
  methods: {
    /* 父组件调用，刷新内容 */
    refreshMenu(deptCode) {
      this.deptCode = deptCode;
      this.menuList = []; //全部菜单列表
      this.meunBtnList = []; //菜单按钮列表
      this.menuAssignedList = []; //已授权菜单列表
      this.btnAssignedList = []; //已授权按钮列表

      this.menuCheckedKeys = []; //已选菜单
      this.menuHalfCheckedKeys = []; //半选菜单

      this.checkedBtns = []; //选中的按钮列表
      this.checkedBtnNodes = []; //选中的按钮对象列表

      this.selectMenuCode = []; //用户点击过并获取了按钮列表的menu
      this.isDialogShow = true;
      this.getAllMenu();
    },
    /* 获取全部菜单列表 */
    getAllMenu() {
      getAllMenuService().then(
        res => {
          if (res.resultCode == 0) {
            this.menuList = res.data.children;
            this.getDeptAssginMenu();
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 菜单点击回调事件 */
    MenuNodeClick(menu) {
      this.menuSelected = menu.id;
      if (menu.state == "open") {
        this.getMenuBtnList(menu.id);
      }
    },
    /* 按钮多选回调 */
    btnCheckChanged(data, checked, indeterminate) {
      //判断selectMenuCode里有没有该菜单
      if (this.selectMenuCode.indexOf(this.menuSelected) <= -1) {
        this.selectMenuCode.push(this.menuSelected);
      }
      //选中，加入
      if (checked) {
        console.log("++++++" + data.text, checked, indeterminate);
        //增加菜单按钮对照map中的按钮
        if (
          this.checkedMenuBtns[this.menuSelected] &&
          this.checkedMenuBtns[this.menuSelected].indexOf(data.id) == -1
        ) {
          this.checkedMenuBtns[this.menuSelected].push(data.id);
        }
        let index = this.checkedBtns.indexOf(data.id);
        if (index <= -1) {
          this.checkedBtns.push(data.id);
          this.checkedBtnNodes.push({
            menuCode: this.menuSelected,
            buttonCode: data.id
          });
        }
      }
      //反选，删除
      else {
        console.log("-----" + data.text, checked, indeterminate);
        let index = this.checkedBtns.indexOf(data.id);
        console.log("index = " + index);
        this.checkedBtns.splice(index, 1);
        this.checkedBtnNodes.splice(index, 1);
        //删除菜单按钮对照map中的按钮
        let btnIndex = this.checkedMenuBtns[this.menuSelected].indexOf(data.id);
        this.checkedMenuBtns[this.menuSelected].splice(btnIndex, 1);
      }
    },
    /*  */
    menuBtnClick() {},
    /* 保存按钮回调 */
    saveUserClick() {
      if (this.menuList.length <= 0) {
        this.$alert("当前用户无菜单管理权限", "提示");
        return;
      }
      // let menus = this.menuHalfCheckedKeys.concat(this.menuCheckedKeys);
      let menus = this.$refs.menuTree
        .getHalfCheckedKeys()
        .concat(this.$refs.menuTree.getCheckedKeys());
      console.log(this.checkedBtnNodes);
      let selectMenus = "";
      this.selectMenuCode.forEach(menuCode => {
        selectMenus += "," + menuCode;
      });

      this.$confirm(
        "组织权限的改动将影响用户权限，您需要与相关业务方沟通明确后进行此操作",
        "温馨提示"
      ).then(() => {
        this.changeDeptMenu(
          menus,
          this.checkedBtnNodes,
          selectMenus.substring(1)
        );
      });
    },
    /* 关闭弹窗，清空数据 */
    hideDialog() {
      this.menuAssignedList = [];
      this.btnAssignedList = [];
      this.menuList = [];
      this.meunBtnList = [];
      //清空树
      this.menuAssignedList.forEach(menu => {
        this.$refs.menuTree.setChecked(menu.id, false);
      });
      this.btnAssignedList.forEach(btn => {
        this.$refs.btnTree.setChecked(btn.id, false);
      });
      this.isDialogShow = false;
    },
    /* 获取菜单包含按钮列表 */
    getMenuBtnList(menuCode) {
      let requestParam = {
        menuCode: menuCode
      };
      getMenuBtnListService(requestParam).then(
        res => {
          if (res.resultCode == 0) {
            this.meunBtnList = res.data.children;

            //判断菜单是否点击过
            let isCheckd = this.selectMenuCode.indexOf(menuCode);
            if (isCheckd == -1) {
              //未点击过，请求接口获取已授权的按钮
              this.getDeptGrantMenu(menuCode);
            } else {
              //点击过，找到选中的按钮,并设置选中状态
              let assignedList = this.checkedMenuBtns[menuCode];
              this.setBtnChecked(assignedList);
            }
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 获取菜单包含按钮已授权列表 */
    getDeptGrantMenu(menuCode) {
      let requestParam = {
        menuCode: menuCode,
        deptCode: this.deptCode
      };
      getDeptGrantMenuBtnService(requestParam).then(
        res => {
          if (res.resultCode == 0) {
            let assignedList = res.data;
            this.btnAssignedList = [];
            assignedList.forEach(btn => {
              this.btnAssignedList.push(btn.buttonCode);
            });
            console.log("btnAssignedList=" + this.btnAssignedList);
            this.checkedMenuBtns[menuCode] = this.btnAssignedList;
            this.$refs.btnTree.setCheckedKeys(this.btnAssignedList);
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 设置按钮选中 */
    setBtnChecked(assignedList) {
      this.btnAssignedList = [];
      assignedList.forEach(buttonCode => {
        this.btnAssignedList.push(buttonCode);
      });
      this.$refs.btnTree.setCheckedKeys(this.btnAssignedList);
    },
    /* 获取角色已授权菜单列表 */
    getDeptAssginMenu() {
      let requestParam = {
        deptCode: this.deptCode
      };
      getDeptAssginMenuService(requestParam).then(
        res => {
          if (res.resultCode == 0) {
            res.data.forEach(id => {
              this.findMenuForDefault(id, this.menuList);
            });

            this.$refs.menuTree.setCheckedKeys(this.menuAssignedList);
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    findMenuForDefault(menuCode, menuList) {
      for (let i = 0; i < menuList.length; i++) {
        let menu = menuList[i];
        //如果直接找到菜单，判断是否叶子节点，如果是叶子节点插入选中列表
        if (menu.id == menuCode && menu.children.length <= 0) {
          this.menuAssignedList.push(menu.id);
          return;
        }
        //如果没找到菜单，判断是否有子菜单，如果有则循环子菜单
        if (menu.children.length > 0) {
          let isFind = this.findMenuForDefault(menuCode, menu.children);
          // if(isFind) return true;
        }
      }
      // return false;
    },
    /* 菜单授权保存 */
    changeDeptMenu(menuCodes, menuBtns, selectMenuCode) {
      let requestParam = {
        deptId: this.deptCode,
        menuList: menuCodes,
        buttonList: menuBtns,
        selectMenuCode: selectMenuCode,
        userCode: sessionStorage.getItem("userCode")
      };
      changeDeptMenuService(requestParam).then(
        res => {
          console.log(res);
          if (res.resultCode == 0) {
            this.$alert("授权成功", "提示");
            this.isDialogShow = false;
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.roleMenuAssignDialog {
  // height: 100%;
  background-color: white;
}
.screenPanel {
  text-align: left;
  min-height: 40px;
  padding: 16px 0 0 0;
}
.handlePanel {
  text-align: right;
  // padding: 0 20px;
}
.menuTitlePanel {
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  margin-bottom: 1px;
  padding: 10px 32px;
  background-color: #fff;
}
.operatePanel {
  text-align: right;
  margin: 16px 0;
}
.el-select {
  width: 100%;
}
.el-form-item__label {
  text-align: left;
}
.el-main {
  padding: 0 8px !important;
}
.el-aside .el-tree {
  background-color: #fff;
  min-height: 90%;
}
/deep/.el-dialog__body {
  height: 500px;
  background-color: #f2f3f7;
}
.el-footer {
  text-align: right;
}
// /deep/.el-dialog {
//   width: 80%;
// }
</style>
